import "./ArtificialIntelligence";
import "./CustomContext";
import "./General";
import "./People";
import "./Request";
import "./SLA";
import "./Tasks";

import { sectionRegistry } from "./base";

export default sectionRegistry;
